<template lang="html">
  <v-footer  color="grey lighten-2">
    <v-flex class="py-4 px-sm-12 my-2 mx-sm-12">
      <v-row v-if="true">
        <v-col cols="12" class="col-sm-6">
          <h5 class="text-h5">About {{getPlatform}}</h5>
          <p><a href="/">{{getPlatform}}</a> is a product of Iceverg Ventures SL</p>
        </v-col>
        <v-col class="col-sm-6">
          <h5 class="text-h5">Quick links</h5>
          <p>
            <a href="/legal">Legal</a> |
            <a href="/privacy">Privacy</a> |
            <a href="/cookie-policy">Cookies policy</a>
          </p>
        </v-col>
      </v-row>
      <v-row v-if="true">
        <v-col><v-divider></v-divider></v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <cookie-law :message="cookieMessage"
            :button-link="'/cookie-policy'"
            button-link-text="Cookie policy"
            ></cookie-law>
          Copyright &copy;{{ new Date().getFullYear() }} — <strong>{{getPlatform}}</strong>
        </v-col>
      </v-row>
    </v-flex>

  </v-footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
  export default {
    name: 'Footer',
    components: {
      CookieLaw
    },
    data: () => {
        return {
            platform: process.env.VUE_APP_PLATFORM,
            cookieMessage: `This website uses cookies to ensure you get the best experience on our website.
            You can read more about our cookie policy.
            By keeping browsing we understand you give your consent to our cookies policy`
        }
    },
    computed: {
      getPlatform(){
        return this.platform.charAt(0).toUpperCase() + this.platform.slice(1)
      }
    }
  }
</script>

<style lang="css">
.Cookie__buttons a.Cookie__button{
  background-color: #ccc;
  text-decoration: none;
}
</style>
